import React from 'react';
import  {Link}  from 'react-router-dom';
import './menucliente.css';

function MenuCliente(){
    return <nav className="navbar fixed-top navbar-expand-md navbar-dark"> 
    <div className="container">
      
          <a className="navbar-brand" href="/">iSolution</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">  

              <ul className="navbar-nav">
                  <li className="nav-item">
                      <Link to="/app/home" className="nav-link" aria-current="page">Início</Link>
                  </li> 
                  <li className="nav-item">
                      <Link to="/app/tutorial" className="nav-link" aria-current="page">Tutorial</Link>
                  </li>
                  <li className="nav-item">
                      <Link to="/app/historico" className="nav-link" aria-current="page">Histórico Financeiro</Link>
                  </li>
                  <li className="nav-item">
                      <Link to="/app/emissao" className="nav-link" aria-current="page">Emissão de Boleto</Link>
                  </li>
                  <li className="nav-item">
                      <Link to="/app/renovacao" className="nav-link" aria-current="page">Renovação de Contrato</Link>
                  </li>
                  <li className="nav-item">
                      <Link to="/app" className="nav-link" aria-current="page">Sair</Link>
                  </li>
              </ul>
          </div>
    </div>
</nav> ;
  }

export default MenuCliente;